import { action, observable, runInAction } from 'mobx';

import BancoService from '../services/BancoService';
import BeneficiarioService from '../services/BeneficiarioService';
import DemonstrativoService from '../services/DemonstrativoService';
import FaturaService from '../services/FaturaService';
import GlosaService from '../services/GlosaService';
import OrgaoExternoService from '../services/OrgaoExternoService';
import PrestadorService from '../services/PrestadorService';
import ProfissionalService from '../services/ProfissionalService';
import TipoAtendimentoService from '../services/TipoAtendimentoService';
import TipoSituacaoServidorService from '../services/TipoSituacaoServidorService';
import UfService from '../services/UfService';
import AcertoMensalidadeService from '../services/AcertoMensalidadeService';
import AcertoCoparticipacaoService from '../services/AcertoCoparticipacaoService';
import DividaServDesligadoService from '../services/DividaServDesligadoService';
import AcertosDiversosService from '../services/AcertosDiversosService';

class AplicacaoStore {
  @observable beneficiarios = [];
  @observable tiposDeAtendimento = [];
  @observable tiposDeSituacao = [];
  @observable motivosDeGlosa = [];
  @observable prestadores = [];
  @observable prestadoresCredenciados = [];
  @observable faturas = [];
  @observable orgaosExternos = [];
  @observable bancos = [];
  @observable demonstrativos = [];
  @observable profissionais = [];
  @observable especialidades = [];
  @observable CROs = [];
  @observable UFs = [];
  @observable grupos = [];
  @observable protocolosAcerto = [];
  @observable origensAcerto = [];
  @observable estadosAcerto = [];
  @observable protocolosAcertoCopart = [];
  @observable tiposAcertoCopart = [];
  @observable estadosAcertoCopart = [];
  @observable protocolosAcertosDiversos = [];
  @observable eventosDividaServDesligado = [];
  @observable tiposDividaServDesligado = [];
  @observable servidoresDesligados = [];

  beneficiarioService = new BeneficiarioService();
  tipoAtendimentoService = new TipoAtendimentoService();
  tiposDeSituacaoService = new TipoSituacaoServidorService();
  glosaService = new GlosaService();
  prestadorService = new PrestadorService();
  faturaService = new FaturaService();
  orgaoExternoService = new OrgaoExternoService();
  bancoService = new BancoService();
  demonstrativoService = new DemonstrativoService();
  profissionalService = new ProfissionalService();
  ufService = new UfService();
  acertoMensalidadeService = new AcertoMensalidadeService();
  acertoCoparticipacaoService = new AcertoCoparticipacaoService();
  acertosDiversosService = new AcertosDiversosService();
  dividaServDesligadoService = new DividaServDesligadoService();

  @action getBeneficiarios = async () => {
    if (this.beneficiarios === undefined || this.beneficiarios.length === 0) {
      const beneficiarios = await this.beneficiarioService.consultarNomes();
      runInAction(() => {
        this.beneficiarios = beneficiarios;
      });
    }
    return this.beneficiarios;
  }

  @action getTiposDeAtendimento = async () => {
    if (this.tiposDeAtendimento === undefined || this.tiposDeAtendimento.length === 0) {
      const tiposDeAtendimento = await this.tipoAtendimentoService.consultarTiposAtendimento();
      runInAction(() => {
        this.tiposDeAtendimento = tiposDeAtendimento;
      });
    }

    return this.tiposDeAtendimento;
  }
  @action getTiposDeSituacao = async () => {
    if (this.tiposDeSituacao === undefined || this.tiposDeSituacao.length === 0) {
      const tiposDeSituacao = await this.tiposDeSituacaoService.consultarTiposSituacao();
      runInAction(() => {
        this.tiposDeSituacao = tiposDeSituacao;
      });
    }
    return this.tiposDeSituacao;
  }
  @action getMotivosDeGlosa = async () => {
    if (this.motivosDeGlosa === undefined || this.motivosDeGlosa.length === 0) {
      const motivosDeGlosa = await this.glosaService.consultarMotivosDeGlosa();
      runInAction(() => {
        this.motivosDeGlosa = motivosDeGlosa;
      });
    }
    return this.motivosDeGlosa;
  }

  @action getPrestadores = async () => {
    if (this.prestadores === undefined || this.prestadores.length === 0) {
      const prestadores = await this.prestadorService.consultarNomesTodosPrestadores();
      runInAction(() => {
        this.prestadores = prestadores;
      });
    }
    return this.prestadores;
  }

  @action getPrestadoresCredenciados = async () => {
    if (this.prestadoresCredenciados === undefined || this.prestadoresCredenciados.length === 0) {
      const prestadoresCredenciados = await this.prestadorService.consultarNomesTodosPrestadoresCredenciados();
      runInAction(() => {
        this.prestadoresCredenciados = prestadoresCredenciados;
      });
    }
    return this.prestadoresCredenciados;
  }

  @action getFaturas = async () => {
    if (this.faturas === undefined || this.faturas.length === 0) {
      const faturas = await this.faturaService.consultarCodigoENumeroFaturas();
      runInAction(() => {
        this.faturas = faturas;
      });
    }
    return this.faturas;
  }

  @action getOrgaosExternos = async () => {
    if (this.orgaosExternos === undefined || this.orgaosExternos.length === 0) {
      const orgaosExternos = await this.orgaoExternoService.consultarOrgaosExternos();
      runInAction(() => {
        this.orgaosExternos = orgaosExternos;
      });
    }
    return this.orgaosExternos;
  }

  @action getBancos = async () => {
    if (this.bancos === undefined || this.bancos.length === 0) {
      const bancos = await this.bancoService.consultarBancos();
      runInAction(() => {
        this.bancos = bancos;
      });
    }
    return this.bancos;
  }

  @action getDemonstrativos = async () => {
    if (this.demonstrativos === undefined || this.demonstrativos.length === 0) {
      const demonstrativos = await this.demonstrativoService.consultarDemonstrativos();
      runInAction(() => {
        this.demonstrativos = demonstrativos;
      });
    }
    return this.demonstrativos;
  }

  @action getUfs = async () => {
    if (this.UFs === undefined || this.UFs.length === 0) {
      const UFs = await this.ufService.consultarUFs();
      runInAction(() => {
        this.UFs = UFs;
      });
    }
    return this.UFs;
  }
  @action getProfissionais = async () => {
    if (this.profissionais === undefined || this.profissionais.length === 0) {
      const profissionais = await this.profissionalService.consultarNomesTodosProfissionais();
      runInAction(() => {
        this.profissionais = profissionais;
      });
    }
    return this.profissionais;
  }

  @action getEspecialidades = async () => {
    if (this.especialidades === undefined || this.especialidades.length === 0) {
      const especialidades = await this.profissionalService.consultarEspecialidades();
      runInAction(() => {
        this.especialidades = especialidades;
      });
    }
    return this.especialidades;
  }

  @action getCROs = async () => {
    if (this.CROs === undefined || this.CROs.length === 0) {
      const CROs = await this.profissionalService.consultarCROs();
      runInAction(() => {
        this.CROs = CROs;
      });
    }
    return this.CROs;
  }

  @action getGrupos = async () => {
    if (this.grupos === undefined || this.grupos.length === 0) {
      const grupos = await this.prestadorService.consultarNomesTodosGrupos();
      runInAction(() => {
        this.grupos = grupos;
      });
    }
    return this.grupos;
  }
  @action getProtocolosAcerto = async () => {
    if (this.protocolosAcerto === undefined || this.protocolosAcerto.length === 0) {
      const protocolosAcerto = await this.acertoMensalidadeService.consultarTodosOsProtocolos();
      runInAction(() => {
        this.protocolosAcerto = protocolosAcerto;
      });
    }
    return this.protocolosAcerto;
  }
  @action getOrigensAcerto = async () => {
    if (this.origensAcerto === undefined || this.origensAcerto.length === 0) {
      const origensAcerto = await this.acertoMensalidadeService.consultarOrigens();
      runInAction(() => {
        this.origensAcerto = origensAcerto;
      });
    }
    return this.origensAcerto;
  }
  @action getEstadosAcerto = async () => {
    if (this.estadosAcerto === undefined || this.estadosAcerto.length === 0) {
      const estadosAcerto = await this.acertoMensalidadeService.consultarEstados();
      runInAction(() => {
        this.estadosAcerto = estadosAcerto;
      });
    }
    return this.estadosAcerto;
  }
  @action getProtocolosAcertoCopart = async () => {
    if (this.protocolosAcertoCopart === undefined || this.protocolosAcertoCopart.length === 0) {
      const protocolosAcertoCopart = await this.acertoCoparticipacaoService.consultarTodosOsProtocolos();
      runInAction(() => {
        this.protocolosAcertoCopart = protocolosAcertoCopart;
      });
    }
    return this.protocolosAcertoCopart;
  }
  @action getTiposAcertoCopart = async () => {
    if (this.tiposAcertoCopart === undefined || this.tiposAcertoCopart.length === 0) {
      const tiposAcertoCopart = await this.acertoCoparticipacaoService.consultarTipos();
      runInAction(() => {
        this.tiposAcertoCopart = tiposAcertoCopart;
      });
    }
    return this.tiposAcertoCopart;
  }
  @action getEstadosAcertoCopart = async () => {
    if (this.estadosAcertoCopart === undefined || this.estadosAcertoCopart.length === 0) {
      const estadosAcertoCopart = await this.acertoCoparticipacaoService.consultarEstados();
      runInAction(() => {
        this.estadosAcertoCopart = estadosAcertoCopart;
      });
    }
    return this.estadosAcertoCopart;
  }
  @action getProtocolosAcertosDiversos = async () => {
    if (this.protocolosAcertosDiversos === undefined || this.protocolosAcertosDiversos.length === 0) {
      const protocolosAcertosDiversos = await this.acertosDiversosService.consultarTodosOsProtocolos();
      runInAction(() => {
        this.protocolosAcertosDiversos = protocolosAcertosDiversos;
      });
    }
    return this.protocolosAcertosDiversos;
  }
  @action getEventosDividas = async () => {
    if (this.eventosDividaServDesligado === undefined || this.eventosDividaServDesligado.length === 0) {
      const eventosDividaServDesligado = await this.dividaServDesligadoService.consultarEventos();
      runInAction(() => {
        this.eventosDividaServDesligado = eventosDividaServDesligado;
      });
    }
    return this.eventosDividaServDesligado;
  }
  @action getTiposDividas = async () => {
    if (this.tiposDividaServDesligado === undefined || this.tiposDividaServDesligado.length === 0) {
      const tiposDividaServDesligado = await this.dividaServDesligadoService.consultarTipos();
      runInAction(() => {
        this.tiposDividaServDesligado = tiposDividaServDesligado;
      });
    }
    return this.tiposDividaServDesligado;
  }
  @action getServidoresDesligados = async () => {
    if (this.servidoresDesligados === undefined || this.servidoresDesligados.length === 0) {
      const servidoresDesligados = await this.dividaServDesligadoService.consultarServidoresDesligados();
      runInAction(() => {
        this.servidoresDesligados = servidoresDesligados;
      });
    }
    return this.servidoresDesligados;
  }
}

export default AplicacaoStore;
